export const SET_TOKEN = 'SET_TOKEN'

export const SET_EXPIRE = 'SET_EXPIRE'

export const SET_LOGINGO = 'SET_LOGINGO'

export const SET_ACCOUNTDATA = 'SET_ACCOUNTDATA'
